import React, { useState, useEffect } from "react";
import axios from "axios";
import { useParams, useHistory } from "react-router-dom";
import { FiEye, FiEyeOff, FiArrowLeft } from "react-icons/fi";
import Footer from "components/Footers/Footer";

function ResetMdp() {
  const { token, email: encodedEmail } = useParams();
  const [email, setEmail] = useState("");
  const [mdp, setMdp] = useState("");
  const [mdpConfirm, setMdpConfirm] = useState("");
  const [showMdp, setShowMdp] = useState(false);
  const [showMdpConfirm, setShowMdpConfirm] = useState(false);
  const [message, setMessage] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const history = useHistory();

  useEffect(() => {
    if (encodedEmail) {
      try {
        const decodedEmail = decodeURIComponent(encodedEmail);
        if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(decodedEmail)) {
          setEmail(decodedEmail);
        } else {
          setError("Email invalide dans le lien");
        }
      } catch (e) {
        setError("Erreur de décodage de l'email");
      }
    }
  }, [encodedEmail]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage(null);
    setError(null);

    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      setError("Veuillez fournir un email valide");
      return;
    }
    if (mdp.length < 6) {
      setError("Le mot de passe doit comporter au moins 6 caractères");
      return;
    }
    if (mdp !== mdpConfirm) {
      setError("Les mots de passe ne correspondent pas");
      return;
    }

    setLoading(true);

    try {
      const response = await axios.post(
        "https://appapi.unpaidfinancial.com/api/reset-password",
        {
          token,
          email,
          mdp,
          mdp_confirmation: mdpConfirm,
        }
      );
      setMessage(response.data.message || "Mot de passe changé avec succès !");
      setTimeout(() => history.push("/login"), 2000);
    } catch (err) {
      if (err.response?.status === 422) {
        setError(
          "Données invalides : " +
            Object.values(err.response.data.errors).flat().join(", ")
        );
      } else {
        setError(
          err.response?.data?.message || "Erreur lors de la réinitialisation"
        );
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-gray-800 via-blue-gray-700 to-blue-gray-400" style={{marginTop:'30px'}}>
      <div
        className="w-full max-w-md mx-auto glass-effect px-6 py-8 sm:px-10 sm:py-12 rounded-3xl shadow-2xl"
        style={{
          backdropFilter: "blur(8px)",
          background: "rgba(30,41,59,0.85)",
          border: "1.5px solid rgba(71,85,105,0.25)",
        }}
      >
        {/* Retour */}
        <button
          onClick={() => history.goBack()}
          className="mb-8 flex items-center text-blue-gray-200 hover:text-blue-400 transition-colors focus:outline-none"
        >
          <FiArrowLeft className="mr-2" size={18} />
          <span className="text-base font-medium">Retour</span>
        </button>

        <div className="mb-8 text-center">
          <h1 className="text-2xl font-extrabold text-white tracking-tight drop-shadow">
            Réinitialise ton mot de passe
          </h1>
          <p className="text-base text-white mt-2">
            Saisissez un nouveau mot de passe pour continuer !
          </p>
        </div>

        {/* Alertes */}
        {message && (
          <div className="mb-6 p-3 bg-green-100/20 text-white rounded text-sm border border-white text-center shadow-sm animate-pop">
            {message}
          </div>
        )}
        {error && (
          <div className="mb-6 p-3 bg-red-100/20 text-white rounded text-sm border border-white text-center shadow-sm animate-pop">
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit} className="space-y-7">
          <input type="hidden" name="email" value={email} />

          {/* Email */}
          <div>
            <label className="block text-xs text-white mb-1">
              Réinitialisation pour
            </label>
            <div className="font-semibold text-white truncate text-base bg-blue-gray-700/50 rounded px-3 py-2 border border-blue-gray-500/30 select-text">
              {email}
            </div>
          </div>

          {/* Nouveau mot de passe */}
          <div>
            <label className="block mb-1 text-sm text-white font-semibold">
              Nouveau mot de passe
            </label>
            <div className="relative">
              <input
                type={showMdp ? "text" : "password"}
                value={mdp}
                onChange={(e) => setMdp(e.target.value)}
                className="w-full border border-blue-gray-500/30 rounded-lg px-4 py-3 bg-blue-gray-900/60 text-bluegray-800 font-medium focus:ring-2 focus:ring-blue-400 focus:border-blue-400 outline-none transition text-base placeholder:text-blue-gray-300/60"
                placeholder="Au moins 6 caractères"
                required
                minLength={6}
                autoComplete="new-password"
              />
              <button
                type="button"
                className="absolute top-0 bottom-0 right-0 pr-3 flex items-center h-full text-bluegray-800 hover:text-blue-400 focus:text-blue-400 transition"
                onClick={() => setShowMdp(!showMdp)}
                tabIndex={-1}
              >
                {showMdp ? <FiEyeOff size={22} /> : <FiEye size={22} />}
              </button>
            </div>
          </div>

          {/* Confirmer */}
          <div>
            <label className="block mb-1 text-sm text-white font-semibold">
              Confirmez le mot de passe
            </label>
            <div className="relative">
              <input
                type={showMdpConfirm ? "text" : "password"}
                value={mdpConfirm}
                onChange={(e) => setMdpConfirm(e.target.value)}
                className="w-full border border-blue-gray-500/30 rounded-lg px-4 py-3 bg-blue-gray-900/60 text-bluegray-800 font-medium focus:ring-2 focus:ring-blue-400 focus:border-blue-400 outline-none transition text-base placeholder:text-blue-gray-300/60"
                placeholder="Confirme ton mot de passe"
                required
                minLength={6}
                autoComplete="new-password"
              />
              <button
                type="button"
                className="absolute top-0 bottom-0 right-0 pr-3 flex items-center h-full text-blue-gray-400 hover:text-blue-400 focus:text-blue-400 transition"
                onClick={() => setShowMdpConfirm(!showMdpConfirm)}
                tabIndex={-1}
              >
                {showMdpConfirm ? <FiEyeOff size={22} /> : <FiEye size={22} />}
              </button>
            </div>
          </div>
          <div className="flex flex-col md:flex-row gap-3 mt-2">
          <button
            type="submit"
            disabled={loading}
            className={`flex-1 py-2 px-3 rounded-lg font-semibold bg-white hover:bg-blue-gray-300 text-blue-gray-800 shadow transition-all text-sm flex items-center justify-center gap-2 ${
              loading ? "opacity-60 cursor-not-allowed" : ""
            }`}
          >
            {loading ? (
              <span className="flex items-center justify-center gap-2">
                <svg
                  className="animate-spin h-4 w-4"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <circle
                    className="opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    strokeWidth="4"
                  ></circle>
                  <path
                    className="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                  ></path>
                </svg>
                En cours...
              </span>
            ) : (
              "Réinitialiser"
            )}
          </button>
          <button
            type="button"
            onClick={() => history.push("/forgot")}
            className="flex-1 py-2 px-3 rounded-lg font-semibold bg-white border border-blue-gray-400 text-blue-gray-700 hover:bg-blue-gray-200 hover:text-blue-gray-900 transition-all text-sm"
            tabIndex={-1}
          >
            Annuler
          </button>
        </div>
        </form>
        
        <br />
        <br />
        <br />
      </div>

      <style>{`
        .glass-effect {
          box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.18);
          backdrop-filter: blur(10px) saturate(180%);
        }
        @media (max-width: 600px) {
          .glass-effect {
            padding: 1.5rem !important;
            border-radius: 1.3rem !important;
          }
        }
        .animate-pop {
          animation: pop-bounce 0.6s cubic-bezier(.23,1.22,.49,.97);
        }
        @keyframes pop-bounce {
          0% { transform: scale(0.7); opacity: 0.4;}
          60% { transform: scale(1.08);}
          100% { transform: scale(1); opacity: 1;}
        }
      `}</style>
    </div>
  );
   ;
}

export default ResetMdp;
